import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import TopicFeed from "./components/TopicFeed";
import DanmakuStage from "./components/DanmakuStage";
import Voices from "./components/Voices";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  useEffect(() => {
    // keep canonical aligned with the actual visiting URL
    const link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (link) link.href = window.location.href;
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <HotBoard />
        <TopicFeed />
        <DanmakuStage />
        <Voices />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}